import { Directive, ViewContainerRef } from '@angular/core';

/**
 * directive host-view-container : pour obtenir une référence du container qui l'utilise
 */
@Directive({
  selector: '[host-view-container]',
})
export class HostViewHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
